import { cn } from "@/lib/utils";
import { TabsList, TabsTrigger } from "../ui";
import { routes } from "@/routes/utils";

const CustomTabList = ({
  tabs,
  className,
  currentTab,
  action,
}: {
  tabs: any;
  className?: string;
  currentTab?: string;
  action?: string;
}) => {
  const isAdd = action == routes.add;
  return (
    <div className="w-full overflow-hidden overflow-x-auto">
      <TabsList className={cn("gap-x-4 bg-transparent mb-4", className)}>
        {tabs.map((tab: { title: string; value: string }) => (
          <TabsTrigger
            value={tab.value}
            key={`tab-${tab.value}`}
            className={cn(
              "py-3 lg:py-5 text-[16px] -leading-[0.5%] text-g-300 font-[300] px-0 border-0 shadow-none data-[state=active]:shadow-none data-[state=active]:rounded-none data-[state=active]:bg-transparent data-[state=active]:border-b-2 data-[state=active]:border-b-primary data-[state=active]:text-black data-[state=active]:font-bold cursor-pointer"
            )}
            disabled={
              isAdd && currentTab
                ? Number(tab.value) != Number(currentTab)
                : false
            }
          >
            {tab.title}
          </TabsTrigger>
        ))}
      </TabsList>
    </div>
  );
};

export default CustomTabList;
